export default {
  "component.tagSelect.expand": "Expand",
  "component.tagSelect.collapse": "Collapse",
  "component.tagSelect.all": "All",
  "component.agentLevel.platform": "Platform",
  "component.agentLevel.level1": "Level 1 Agent",
  "component.agentLevel.level2": "Level 2 Agent",
  "component.agentLevel.merchant": "Merchant",
  "component.xterm.status.idle": "Idle",
  "component.xterm.status.connecting": "Connecting",
  "component.xterm.status.running": "Running",
  "component.xterm.status.completed": "Completed",
  "component.xterm.status.error": "Error",
  "component.worldMap.noData": "No map data",
  "component.worldMap.loading": "Loading map...",
};
